import styled from 'styled-components'
import { RefreshIcon } from "../../../assets/refresh_icon";


const Button = styled.button` 
    background: #40e5a0; 
    border-radius: 4px; 
    border: none;
    display: flex;
    align-items: center;



    &:hover{
        background: #118052; 

    }

    &:active{
        filter: brightness(0.8);

    }



`;


export const RefreshButton = ({ onConfirm, size, style }) => (
    <Button title="Atualizar" style={style} onClick={onConfirm} >
        <RefreshIcon fill="#fff" aspect={size} />
    </Button >

) 